/**
 * @ngdoc directive
 * @name programlist
 *
 * @description
 * List of programs
 */
module.directive('programlist', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            missions: '=content'
        },
        link: function ($scope) {
            $scope.nocontent = 'Aucune mission à afficher';
        },
        template:
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-missions--title">{{label}}</span></h2>' +
                '    <mission ng-repeat="content in missions" index="{{$index}}" content="content"></mission>' +
                '    <div ng-if="missions.length === 0" class="aqua-richtext"><p class="l-tac">{{nocontent}}</p></div>' +
                '  </div>'
    };
});